import { toFetchableStorageUrl } from 'shared/utils/storage-url';

/**
 * Loads a picture a scene draws (a team logo). `crossOrigin = 'anonymous'` is set before `src`: an image from
 * another origin without it taints the canvas, and `VideoFrame` from a tainted canvas throws in the middle of the
 * assembly. Resolves `null` when there is no URL or it does not load — the scene draws its empty slot instead.
 *
 * The storage bucket answers CORS only to the deployed admins, so under the dev server a logo goes through its
 * proxy (`toFetchableStorageUrl`); in a build the URL stays as is.
 */
export function loadSceneImage(url: string | undefined | null): Promise<HTMLImageElement | null> {
  if (!url) return Promise.resolve(null);
  return new Promise((resolve) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';
    image.onload = () => resolve(image);
    image.onerror = () => resolve(null);
    image.src = toFetchableStorageUrl(url);
  });
}

/** Lets the browser drop the decoded picture now instead of when the scene is collected. */
export function releaseSceneImage(image: HTMLImageElement | null): void {
  if (!image) return;
  image.onload = null;
  image.onerror = null;
  image.removeAttribute('src');
}
